export default __webpack_public_path__ + "media/images/social-instagram-a6575fcdbcd26d4801753d66e156c13e.svg";